import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

import { AlertService } from "../../services/alert/alert.service";
import { IceTypes } from "../../models/icetypes";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { provider } from '../../models/domain/provider';
import { appointment } from '../../models/schedule/appointment';
import { provider_index } from '../../models/domain/provider_index';
import { IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings } from '../../components/models/icesettings';
import { provider_reference } from '../../models/domain/provider_reference';
import { Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { IcepanelDialog, IcepanelDialogData } from '../../components/icepaneldialog/icepaneldialog';
import { encounter } from '../../models/ehr/encounter';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class ProviderService extends DomainService {

  providerClaimLoops: any[] = [
    { value: "2310A", name: "Referring Provider" },
    { value: "2310B", name: "Rendering or Performing Provider" },
    { value: "2420A", name: "Rendering Provider" },
    { value: "2420B", name: "Purchased Service Provider" },
    { value: "2310D-2420D", name: "Supervising Provider" },
    { value: "2420E", name: "Ordering Provider" },
  ];

  providerCodeOrEntityOptions: any[] = [
    { value: "DK", loop: "2420E", name: "Ordering Physician" },
    { value: "PE", loop: "2310B", name: "Rendering or Performing Provider" },
    { value: "P3", loop: "2310A-2420F", name: "Primary Care Provider" },
    { value: "QB", loop: "2420B", name: "Purchase Service Provider" },
    { value: "DN", loop: "2310A-2420F", name: "Referring Provider" },
    { value: "DQ", loop: "2310D-2420D", name: "Supervising Physician" },
  ];

  /* To do Use for reverse lookup
    let loop = "2310B";
    switch (proref.provider_code) {
      case "DN":
      case "P3": {
        loop = "2310A";
        break;
      }
      case "PE": {
        loop = "2310D";
        break;
      }
    }
  */

  constructor(http: HttpClient,
    alertSvc: AlertService,
    loginSvc: LoginService) {

    super(http, alertSvc, loginSvc);
  }

  insertProvider(domaintype: IceTypes.ACCOUNT_TYPE, pro: provider, members: string): Observable<any> {
    if (Iceutility.isdefined(pro) == false) throw "Provider service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=&data=addprovider&key=&subkeys=domaintype:" + domaintype.toString() + ";lastname:;members:" + (members == null ? "" : members);
    let tblname = pro.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pro) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER", "FACILITY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  updateProvider(pro: provider, domaintype: IceTypes.ACCOUNT_TYPE, hieUpdateDisable: boolean = false, pros: provider_index[] = null): Observable<any> {
    if (Iceutility.isdefined(pro) == false) throw "Provider service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + pro.trans_account + "&data=updateprovider&key=&subkeys=domaintype:" + domaintype.toString() + ";lastname:" + ";hieupdate:" + (hieUpdateDisable ? "true" : "false");
    let tblname = pro.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pro) + "}";
    if (pros != null && pros.length > 0) {
      try {
        let tempobj = JSON.parse(data);
        tempobj["PROS"] = pros
        let tempjson = JSON.stringify(tempobj);
        data = tempjson;
      }
      catch (e) {
        console.log(e);
      }
    }
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER", "FACILITY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getProviders(): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=&data=&key=&subkeys=domaintype:;lastname:;members:;";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  getPracticeProviders(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, uid: string) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";
    if (domain == null || domain.length == 0) throw "Domain is required.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&key=" + "&subkeys=uid:" + uid + "&data=practiceproviders" + "&acttype=" + domaintype;
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getAppointment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, apptkey: string) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";
    if (domain == null || domain.length == 0) throw "Domain is required.";
    if (apptkey == null || apptkey.length == 0) throw "Appointment key is required.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&key=" + apptkey + "&data=appointment" + "&acttype=" + domaintype + "&patientdomain=&subkeys=";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  insertUpdateAppointment(appointmentdata: appointment, domain: string, ptdomain: string, domaintype: IceTypes.ACCOUNT_TYPE): Observable<any> {
    if (Iceutility.isdefined(appointmentdata) == false) throw "Provider service Insert/Update appointment has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = ""; 
    if (appointmentdata.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=appointment&subkeys=&key=&acttype=" + domaintype;
    } else {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=updateappointment&subkeys=&key=" + appointmentdata.appointment_key + "&acttype=" + domaintype;
    }

    let tblname = appointmentdata.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(appointmentdata) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  insertUpdateEncounter(encounterdata: encounter, domain: string, ptdomain: string, domaintype: IceTypes.ACCOUNT_TYPE): Observable<any> {
    if (Iceutility.isdefined(encounterdata) == false) throw "Provider service Insert/Update encounter has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = "";
    if (encounterdata.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=encounter&subkeys=&key=&acttype=" + domaintype;
    } else {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=updateencounter&subkeys=&key=" + encounterdata.encounter_key + "&acttype=" + domaintype;
    }

    let tblname = encounterdata.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(encounterdata) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["ENCOUNTER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  /////////////////////////////////////
  // UX service calls
  doProviderPopup(dialog: MatDialog, practiceProviders: provider_index[], parentPyrBucket: any, proref: provider_reference): Observable<IcepanelDialog> {
    let descText = "";
    if (practiceProviders == null || parentPyrBucket == null || proref == null) return Observable.throw("Error: Invalid Parameter");

    let listOfPracticeProviders = [];
    let selectedProvider = "";
    for (let ipro = 0; ipro < practiceProviders.length; ipro++) {

      let ids = [];
      for (let i = 1; i <= 8; i++) {
        let idCode: string = practiceProviders[ipro]["identification_code" + i.toString()];
        if (idCode == null || idCode.length == 0) continue;
        ids.push(idCode);
      }

      if (proref.trans_account == practiceProviders[ipro].trans_account) {
        descText = "Taxonomy: " + practiceProviders[ipro].taxonomy_code + "\nIDs: " + ids.join(",");
        selectedProvider = JSON.stringify([{ name: practiceProviders[ipro].getdisplayname(false), value: practiceProviders[ipro].trans_account, taxonomy_code: practiceProviders[ipro].taxonomy_code, ids: ids.join(",") }]);
      }

      listOfPracticeProviders.push({ name: practiceProviders[ipro].getdisplayname(false), value: practiceProviders[ipro].trans_account, taxonomy_code: practiceProviders[ipro].taxonomy_code, ids: ids.join(",") });
    }

    let providerLoopsCtrl: IcecontrolSettings = null, providerCtrl: IcecontrolSettings = null, providerCodeCtrl: IcecontrolSettings = null, providerInfoCtrl: IcecontrolSettings = null
    let sections: IcepanelsectionSettings[] = [];

    sections.push(new IcepanelsectionSettings("ProviderSection", { class: ["yalla"], styles: {} }, [],
      [providerCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "400px" }, null, null, "Provider", "Provider")
        .setControlName("trans_account")
        .createFormControl(selectedProvider, [Validators.required])
        .setOptions(listOfPracticeProviders)], null));

    sections.push(new IcepanelsectionSettings("ProviderDescSection", { class: ["yalla"], styles: {} }, [],
      [providerInfoCtrl = new IcecontrolSettings("icetextarea", { width: "400px", height: "300px" }, null, null, "Description", "Description")
        .setControlName("description")
        .createFormControl(descText, [])
        .setReadonly(true)], null));

    sections.push(new IcepanelsectionSettings("ProviderCodeSection", { class: ["yalla"], styles: {} }, [],
      [providerCodeCtrl = new IcecontrolSettings("iceselect", { width: "400px" }, null, null, "ProviderCode", "Provider Type")
        .setControlName("provider_code")
        .createFormControl(proref.provider_code, [Validators.required])
        .setOptions(this.providerCodeOrEntityOptions)], null));

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    providerCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        let ctrl: IcecontrolSettings = <IcecontrolSettings>data.autocompleteSettings;
        try {
          let opObjs = JSON.parse(ctrl.getFormControl().value);
          if (opObjs.length > 0) {
            let fndPro = ctrl.getOptions().filter(o => o.value == opObjs[0].value)
            if (fndPro.length > 0) {
              let descText = "Taxonomy: " + fndPro[0]["taxonomy_code"] + "\nIDs: " + fndPro[0]["ids"];
              providerInfoCtrl.getFormControl().setValue(descText);
            }
          }
        }
        catch (e) {

        }

      },
      err => {
      });

    providerCodeCtrl.createChangeControlEvent().subscribe(
      data => {
        if (data == null) return;
        //providerLoopsCtrl
        //  let payerid = data.value;
        //  let pyrBucket = this.getPayerBucketByPartyKey(payerid);
        //  if (pyrBucket != null) {
        //    let clmInfo = this.getClaimInformation(pyrBucket);
        //    //otherSubInfoCtrl.getFormControl().setValue(clmInfo);
        //  }
        //  else {
        //    //otherSubInfoCtrl.getFormControl().setValue("");
        //  }
      },
      err => {
      });
    let dlgRef = dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: new IcepanelDialogData(
        proref,
        parentPyrBucket,
        new IcepanelSettings("", "", "Provider Type", "", sections, headerControls)
          .enableForm(),
      )
    });

    return dlgRef.afterClosed();
  }

  processProvider(result: any): boolean {
    if (result == null || result.dialogRef == null) return false;

    let ref = result.dialogRef;
    if (result.dialogRef.componentInstance == null) return;
    let pnlData: IcepanelDialogData = <IcepanelDialogData>ref.componentInstance.data;
    if (pnlData == null) return;

    let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>pnlData.headerCtrl;
    if (hdrCtrl == null || hdrCtrl.id == "Close") return;

    let pref: provider_reference = <provider_reference>pnlData.record;
    let parent = pnlData.parentrecord;
    let panel: IcepanelSettings = <IcepanelSettings>pnlData.panel;
    if (panel != null && parent != null && pref != null) {
      let form = panel.getForm();
      if (form != null && form.valid) {
        for (let isec = 0; isec < panel.sections.length; isec++) {
          let sec = panel.sections[isec];
          for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
            let ctrl = sec.controls[ictrl];
            switch (ctrl.getControlName()) {
              case "trans_account": {
                try {
                  let opObjs = JSON.parse(ctrl.getFormControl().value);
                  if (opObjs.length > 0) {
                    let fndPro = ctrl.getOptions().filter(o => o.value == opObjs[0].value)
                    if (fndPro.length > 0) {
                      pref.trans_account = fndPro[0]["value"];
                    }
                  }
                }
                catch (e) {
                  console.log(e);
                }
                break;
              }
              case "provider_code": {
                pref.provider_code = ctrl.getFormControl().value;
                break;
              }
            }
          }
        }
      }
    }
    return true;
  }

  getProviderCodeList(): any[] {
    return this.providerCodeOrEntityOptions;
  }
}
